import { useState, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '@/api/auth.api';
import { toast } from '@/components/ui/toast/Toast';

export const useResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') ?? '';

    const [loading, setLoading] = useState(false);
    const [requestError, setRequestError] = useState('');

    const handleResetPassword = useCallback(async ({ password }) => {
        if (!token) {
            setRequestError('Invalid or expired reset link. Please request a new one.');
            return;
        }

        setLoading(true);
        setRequestError('');

        const data = await resetPassword(token, password);

        if (data?.code === 200) {
            toast.success('Password reset successfully. Please sign in.');
            navigate('/login');
        } else {
            setRequestError(data?.error || 'Failed to reset password. The link may have expired.');
        }

        setLoading(false);
    }, [token, navigate]);

    return { loading, requestError, handleResetPassword };
};